
import { useCallback, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import NFTicon from "@/assets/images/tabbar/NFT.png"
import ConnectWallet from '../common/ConnectWallet';
import nft from "../../assets/images/nftIcon.png"
import wallet from "../../hook/wallet/contentWallet"
import useH5Config from '../../h5/config/useH5Config';
import PromptDialog from '../PromptDialog';
import ButtonComp from '../common/ButtonComp';
import { useTranslation } from "react-i18next"
import NftTradDialog from './NftTard';


const NftMint = () => {
    const { isH5 } = useH5Config()
    const { t } = useTranslation()
    // const { useConnectWallet, useGetWalletAddress } = wallet();
    // const address = useGetWalletAddress()

    const isShowWallet = useRef(false)
    const navigate = useNavigate()
    const [nftLink, setNftLink] = useState(false)

    // useEffect(() => {
    //     if (address) {
    //         // setIsShowWallet(false)
    //         // const url = import.meta.env.VITE_TRADE_URL + address
    //         // setTimeout(() => {
    //         //     WebApp.openLink(url)
    //         // }, 2000)

    //     }
    // }, [address])


    const connectWalletHandle = () => {
        // navigate('/cards?id=1')
        // if (!address) {
        //     useConnectWallet()
        //     // isShowWallet.current = true
        // } else {
        //     const url = import.meta.env.VITE_TRADE_URL + import.meta.env.VITE_MINT_CONTRACT_ADDRESS
        //     WebApp.openLink(url)
        // }
        // if (isH5) {
        //     window.open("https://magiceden.io/collections/bsc/0x7a1Be56dBA9E2E09d0E86b4dD2f4BFA3049a2268", "__blank")
        // }
        setNftLink(true)

    }

    return (
        <>
            <div className={`h-[30px] text-[12px] text-white flex justify-center items-center rounded-[15px] bg-gradient-to-l from-[#18B9B5] to-[#483308]`} style={{ boxShadow: '0px -2px 1px rgba(161,156,253,0.6)' }} onClick={(event) => {
                event.stopPropagation();
                connectWalletHandle()
            }}>
                <img className=' w-5 h-[15px] mr-[3px]' src={NFTicon} alt="" />
                {t("bubble.nft")}</div>
            {
                nftLink && <NftTradDialog callBack={() => setNftLink(false)}></NftTradDialog>
            }
            {/* <PromptDialog isClose={true} title={t("other.attention")} dialog={nftLink} setDialog={setNftLink} callback={() => {
            }} text={t("components.usdt_transform.p_s_t")}>
                <ButtonComp title={t("components.usdt_transform.star_card")} mt={30} callBack={() => {
                    window.open("https://magiceden.io/collections/bsc/0x7a1Be56dBA9E2E09d0E86b4dD2f4BFA3049a2268", "__blank")
                }}></ButtonComp>
                <ButtonComp title={t("components.usdt_transform.star_agent")} mt={20} callBack={() => {
                    const url = "https://magiceden.us/collections/bsc/0x30192E742C33101e7dc9f27676bac592F80688a4"
                    window.open(url, "__blank")
                }}></ButtonComp>
            </PromptDialog> */}

        </>

    )
}


export default NftMint;
